import { config } from '@xingternal/hops';

export const isPreviewOrProduction = (): boolean =>
  ['production', 'preview'].includes(config.appEnv);

export const isDevelopment = () => config.appEnv === 'development';
export const isProduction = () => config.appEnv === 'production';

export const debugApolloEnabled = () => {
  return (
    process.env.JEST_WORKER_ID !== undefined &&
    process.env.TEST_DEBUG_APOLLO === 'true'
  );
};
